<h1 mat-dialog-title>🚧 Modelo en construcción 🚧</h1>
<div mat-dialog-content>
  <p class="text-center">¡Gracias por tu paciencia!</p>
</div>
<div mat-dialog-actions>
  <button mat-button class="btn btn-primary" (click)="onClose()">Entendido</button>
</div>